import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var SelectPage = function (_super) {
  __extends(SelectPage, _super);

  function SelectPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SelectPage.prototype.handleChange = function () {
    this.$emit('input', this.value);
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], SelectPage.prototype, "value", void 0);

  SelectPage = __decorate([Component({})], SelectPage);
  return SelectPage;
}(Vue);

export default SelectPage;